import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e96bdb9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "query-settings" }
const _hoisted_2 = { class: "flex-center-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "GPT settings", -1))
const _hoisted_4 = {
  key: 0,
  class: "settingsWrapper flex-col"
}
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "underline text-sm",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editJson = !_ctx.editJson))
      }, _toDisplayString(_ctx.editJson ? 'Hide' : 'Edit') + " json ", 1)
    ]),
    (!_ctx.editJson)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_InputText, {
            class: "mt-1",
            name: "model",
            value: _ctx.value?.model,
            label: "Model",
            placeholder: 'gpt-3.5-turbo-0613',
            suggestions: _ctx.modelsSuggestions,
            "onUpdate:value": _cache[1] || (_cache[1] = 
                    (newVal) =>
                        _ctx.$emit('update:value', {
                            ..._ctx.value,
                            ['model']: newVal,
                        })
                )
          }, null, 8, ["value", "placeholder", "suggestions"]),
          _createVNode(_component_InputNumber, {
            class: "mt-1",
            name: "max_tokens",
            min: "50",
            max: "4054",
            value: _ctx.value?.max_tokens,
            label: "Max tokens",
            "onUpdate:value": _cache[2] || (_cache[2] = 
                    (newVal) =>
                        _ctx.$emit('update:value', {
                            ..._ctx.value,
                            ['max_tokens']: newVal,
                        })
                )
          }, null, 8, ["value"]),
          _createVNode(_component_InputNumber, {
            class: "mt-1",
            name: "temperature",
            min: "0",
            max: "1",
            step: "0.1",
            value: _ctx.value?.temperature,
            label: "Temperature",
            "onUpdate:value": _cache[3] || (_cache[3] = 
                    (newVal) =>
                        _ctx.$emit('update:value', {
                            ..._ctx.value,
                            ['temperature']: newVal,
                        })
                )
          }, null, 8, ["value"]),
          _createVNode(_component_ToggleSwitch, {
            class: "mt-2",
            value: _ctx.value?.stream ?? true,
            label: "Stream",
            "onUpdate:value": _cache[4] || (_cache[4] = (newVal) =>
                _ctx.$emit('update:value', {
                    ..._ctx.value,
                    ['stream']: newVal,
                }))
          }, null, 8, ["value"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.json) = $event)),
            onInput: _cache[6] || (_cache[6] = ev => _ctx.$emit('update:value', JSON.parse(ev?.target?.value))),
            rows: "15",
            class: "w-full"
          }, null, 544), [
            [_vModelText, _ctx.json]
          ])
        ]))
  ]))
}